import Cookies from "js-cookie";

// Shared cookie attributes. `path: "/"` keeps one cookie for the whole panel,
// `sameSite: "lax"` keeps it first-party, and `secure` requires HTTPS in
// production while still allowing plain-http localhost during development.
export const cookieOptions = () => ({
  expires: 7,
  path: "/",
  sameSite: "lax",
  secure: typeof window !== "undefined" && window.location.protocol === "https:",
});

/** A session exists when the auth token cookie is present and non-empty. */
export const isAuthenticated = () => {
  const token = Cookies.get("authToken");
  return Boolean(token) && token !== "undefined" && token !== "null";
};

/** Remove every auth cookie. Path must match the one used when setting. */
export const clearSession = () => {
  const options = { path: "/" };
  Cookies.remove("authToken", options);
  Cookies.remove("userData", options);
  Cookies.remove("userRole", options);
};
